@if (galleryPermissions().can_edit || section().text_title || section().text_paragraph) {
  <app-section-container
    [index]="sectionIndex()"
    [gallery]="gallery()"
    [section]="section()"
    [galleryPermissions]="galleryPermissions()"
    [darkBackground]="darkBackground()"
    [sections]="sections()"
    [theme]="theme()"
    [insideActions]="true"
    [class.dark-gallery-background]="darkBackground()"
    (addSection)="addSection.emit($event)"
  >
    <ng-container sectionActionsInside>
      @if (isDesktop()) {
        <div class="spaced-button-group-item">
          <app-context-menu
            [options]="{ width: '320px', noSpacing: true }"
            [position]="'right-out'"
            [verticalPosition]="'bottom-in'"
            class="last-button"
            contextHoverIdentifier="section-{{ section().id }}"
            #menu
          >
            <button
              appButton
              name="settings"
              location="edit-text-section"
              [iconButton]="true"
              height="1"
              shape="round"
              contextButton
              appTooltip="Section Settings"
              toolTipOrigin="left"
              color="simple"
            >
              <app-svg src="/assets/icons/mixer.svg"></app-svg>
            </button>
            <div contextContent>
              @if (menu.isOpen()) {
                <app-common-section-settings
                  [section]="section()"
                  [gallery]="gallery()"
                  [theme]="theme()"
                ></app-common-section-settings>
              }
            </div>
          </app-context-menu>
        </div>
      } @else {
        <app-context-menu
          [options]="{ width: '320px', noSpacing: true }"
          class="last-button"
          contextHoverIdentifier="section-{{ section().id }}"
          #menu
        >
          <button
            appButton
            name="settings"
            location="edit-text-section"
            height="1"
            fullWidth="true"
            [hasIcon]="true"
            contextButton
            color="simple"
          >
            <app-svg src="/assets/icons/mixer.svg"></app-svg>
            <span>Options</span>
          </button>
          <div contextContent>
            @if (menu.isOpen()) {
              <app-common-section-settings
                [section]="section()"
                [gallery]="gallery()"
                [theme]="theme()"
              ></app-common-section-settings>
            }
          </div>
        </app-context-menu>
      }
    </ng-container>
    <ng-container sectionContent>
      <app-edit-section-text
        [section]="section()"
        [galleryPermissions]="galleryPermissions()"
        [gallery]="gallery()"
        [theme]="theme()"
        [darkBackground]="darkBackground()"
      ></app-edit-section-text>
    </ng-container>
  </app-section-container>
}
